/**
 * @generated SignedSource<<769f8a94cad95b8ba2ac22da9d4dec3b>>
 * @relayHash c3b6c528ff5c1db364a8092f2ed91cec
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c3b6c528ff5c1db364a8092f2ed91cec

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddProjectV2ItemByIdInput = {
  clientMutationId?: string | null;
  contentId: string;
  projectId: string;
};
export type updateIssueProjectsMutation$variables = {
  connections: ReadonlyArray<string>;
  input: AddProjectV2ItemByIdInput;
};
export type updateIssueProjectsMutation$data = {
  readonly addProjectV2ItemById: {
    readonly projectEdge: {
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"ProjectItemSection">;
      } | null;
    } | null;
  } | null;
};
export type updateIssueProjectsMutation$rawResponse = {
  readonly addProjectV2ItemById: {
    readonly projectEdge: {
      readonly node: {
        readonly fieldValueByName: {
          readonly __typename: "ProjectV2ItemFieldSingleSelectValue";
          readonly __isNode: "ProjectV2ItemFieldSingleSelectValue";
          readonly id: string;
          readonly name: string | null;
        } | {
          readonly __typename: string;
          readonly __isNode: string;
          readonly id: string;
        } | null;
        readonly id: string;
        readonly isArchived: boolean;
        readonly project: {
          readonly id: string;
          readonly template: boolean;
          readonly title: string;
          readonly viewerCanUpdate: boolean;
        };
      } | null;
    } | null;
  } | null;
};
export type updateIssueProjectsMutation = {
  rawResponse: updateIssueProjectsMutation$rawResponse;
  response: updateIssueProjectsMutation$data;
  variables: updateIssueProjectsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateIssueProjectsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddProjectV2ItemByIdPayload",
        "kind": "LinkedField",
        "name": "addProjectV2ItemById",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectV2ItemEdge",
            "kind": "LinkedField",
            "name": "projectEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectV2Item",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ProjectItemSection"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateIssueProjectsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddProjectV2ItemByIdPayload",
        "kind": "LinkedField",
        "name": "addProjectV2ItemById",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectV2ItemEdge",
            "kind": "LinkedField",
            "name": "projectEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectV2Item",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isArchived",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectV2",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "template",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "viewerCanUpdate",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "Status"
                      }
                    ],
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "fieldValueByName",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          }
                        ],
                        "type": "ProjectV2ItemFieldSingleSelectValue",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v2/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": "fieldValueByName(name:\"Status\")"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendEdge",
            "key": "",
            "kind": "LinkedHandle",
            "name": "projectEdge",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "c3b6c528ff5c1db364a8092f2ed91cec",
    "metadata": {},
    "name": "updateIssueProjectsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "0b2916dfea8b705b72e87a36fcffadb1";

export default node;
